// --------------------Quick Fixes----------------------//

function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function searchBoxPlaceholder() {
  const searchInput = $(
    '#headerNav_uc_widgetContainer_ctl03_ctl00_SearchBox1_tbx_searchBox'
  );
  // set a placeholder to searchInput
  searchInput.attr('placeholder', 'Type here...');
}

function modifyWeatherBug() {
  const weatherBugInterval = setInterval(() => {
    const weatherBugDescription = $('#weatherBugDescription').text();
    const weatherBugWidget = $('#weatherBugWidget');

    if (
      !weatherBugWidget.hasClass('weatherBugSet') &&
      weatherBugDescription !== ''
    ) {
      weatherBugWidget.addClass('weatherBugSet');
      const findSpace = weatherBugDescription.lastIndexOf(' ');
      const res = weatherBugDescription.substring(
        findSpace,
        weatherBugDescription.length
      );

      $('#weatherBugDescription').html(res);
    }
  }, 12);

  // Clear interval on page unload to prevent memory leaks
  $(window).on('unload', () => clearInterval(weatherBugInterval));
}

function modifySearchBox() {
  const searchInput = $('.searchBoxInput .inputFieldTextbox');
  searchInput.val('Search');

  searchInput.focus(() => {
    if (searchInput.val() === 'Search') {
      searchInput.val('');
    }
  });

  searchInput.blur(() => {
    if (searchInput.val() === '') {
      searchInput.val('Search');
    }
  });
}
// --------------------CUSTOM----------------------//
function modifyFeatureLineup() {
  $('.featureLineupContainer').each((_, element) => {
    const title = $(element).find('.featureLineup-title');
    const limit = 20;
    let titleText = title.text().trim();
    if (titleText.length > limit) {
      const shortenedTitle = `${titleText.substring(0, limit)}...`;
      title.text(shortenedTitle).attr('title', titleText);
    } else {
      title.text(titleText);
    }
    $(element).find('.featureLineup-buynow a.button').addClass('buyNowButton');
    const moreBtn = $(element)
      .find('.featureLineup-more .button')
      .addClass('buttonSmall');
    const description = $(element).find('.featureLineup-text').eq(1);
    const descriptionText = description.text().trim();
    description
      .html(`<div class="featureLineup-description">${descriptionText}</div>`)
      .append(moreBtn);
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  searchBoxPlaceholder();
  modifySearchBox();
  modifyFeatureLineup();

  // append title to social media icons
  $('.socialNetworks').prepend(
    '<p>Follow this celebration of arts in our high desert community!</p>'
  );
  // append a div to the .footer between .footer-top and .footer-bottom
  $('<div class="footer-separator"></div>').insertAfter('.footer .info');
});

$(window).load(() => {
  // ---
  modifyWeatherBug();
});
